import React from "react";
import { motion } from "framer-motion";
import { ArrowDown } from "lucide-react";
import PaintReveal from "./PaintReveal";

export default function MoltenHero() {
  const go = (id) => {
    const el = document.getElementById(id);
    if (el) el.scrollIntoView({ behavior: "smooth" });
  };

  return (
    <section id="hero" data-testid="hero-section" className="relative w-full h-screen overflow-hidden bg-black">
      <PaintReveal />

      <div className="absolute inset-0 z-[3] flex flex-col items-center justify-center text-center px-5 pointer-events-none">
        <motion.h1
          initial={{ opacity: 0, y: 40, filter: "blur(12px)" }}
          animate={{ opacity: 1, y: 0, filter: "blur(0px)" }}
          transition={{ duration: 1.4, delay: 0.35, ease: [0.16, 1, 0.3, 1] }}
          className="font-display font-medium leading-none gold-fill text-5xl sm:text-7xl lg:text-8xl tracking-tight"
          style={{ WebkitTextStroke: "1px #000", paintOrder: "stroke fill" }}
          data-testid="hero-brand-name"
        >
          CROWN ARTISAN
        </motion.h1>

        <motion.div
          initial={{ opacity: 0, y: 16 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 1, delay: 0.6 }}
          className="mt-12 flex flex-col sm:flex-row items-center gap-4 pointer-events-auto"
        >
          <button data-testid="hero-consultation-cta" onClick={() => go("contact")} className="btn-gold rounded-full px-8 py-4 text-xs tracking-[0.18em] uppercase font-medium">
            Request a Private Consultation
          </button>
          <button data-testid="hero-work-cta" onClick={() => go("work")} className="btn-ghost rounded-full px-8 py-4 text-xs tracking-[0.18em] uppercase">
            Explore Our Work
          </button>
        </motion.div>
      </div>

      <motion.div
        initial={{ opacity: 0 }} animate={{ opacity: 1 }} transition={{ delay: 1.4 }}
        className="absolute z-[4] bottom-6 left-1/2 -translate-x-1/2 flex flex-col items-center gap-2 text-white/50"
        data-testid="hero-scroll-cue"
      >
        <span className="text-[10px] tracking-[0.3em] uppercase">Scroll</span>
        <motion.div animate={{ y: [0, 8, 0] }} transition={{ repeat: Infinity, duration: 1.8 }}>
          <ArrowDown size={16} className="text-[var(--gold)]" />
        </motion.div>
      </motion.div>
    </section>
  );
}
